module.exports = __webpack_public_path__ + "media/images/client-right-at-home-2-8f2b58a451165d836b39f18663d3afb3.png";